<template>
  <div>
    <v-layout row class="mt-3">
      <v-flex xs10 sm4 md3>
        <v-select
          :items="column_items"
          item-value="value"
          v-model="sort_column"
          @change="sortBy()"
          label="Sort by"
          color="black"
          clearable
          hide-details
        ></v-select>
      </v-flex>
      <v-flex xs2 sm4 md3>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'asc'"
          :disabled="asc_desc == 'desc' || sort_column == 'no_default'"
          @click="selectAscDesc('desc')"
        >
          <v-icon small>arrow_downward</v-icon>
        </v-btn>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'desc'"
          :disabled="asc_desc == 'asc' || sort_column == 'no_default'"
          @click="selectAscDesc('asc')"
        >
          <v-icon small>arrow_upward</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="rider_report_list"
      class="elevation-1 mt-4"
      style="background-color:white;padding:10px; border-radius:10px;"
    >
      <template
        slot="headerCell"
        slot-scope="props"
        style="background-color:black;"
      >{{ props.header.text }}</template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ rider_report_list.indexOf(props.item) +1}}</td>
        <td>{{ props.item.status }}</td>
        <td>{{ props.item.rider_name }}</td>
        <td class="text-xs-center">{{ props.item.rider_time_start }}</td>
        <td class="text-xs-center">{{ props.item.rider_tel }}</td>
        <td class="text-xs-center">{{ props.item['serviceFood/Mes/Free'] }}</td>
        <td
          class="text-xs-right"
        >{{ props.item.revenue ? (parseFloat(props.item.revenue).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}}</td>
        <td
          class="text-xs-right"
        >{{ props.item.com ? (parseFloat(props.item.com).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
        <td
          class="text-xs-right"
        >{{ props.item.net_revenue ? (parseFloat(props.item.net_revenue).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
        <td
          class="text-xs-right"
        >{{ props.item.credit ? (parseFloat(props.item.credit).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
        <td
          class="text-xs-right"
        >{{ props.item.tax_com ? (parseFloat(props.item.tax_com).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
        <!-- <td>{{ props.item.cash ? parseFloat(props.item.cash).toFixed(2) : '0.00' }}</td> -->
      </template>
      <template slot="footer">
        <td colspan="5" class="text-xs-center">
          <strong>Total</strong>
        </td>
        <td class="text-xs-center">{{rider_report_summary['serviceFood/Mes/Free']}}</td>
        <td
          class="text-xs-right"
        >{{rider_report_summary.revenue ? parseFloat(rider_report_summary.revenue).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
        <td
          class="text-xs-right"
        >{{rider_report_summary.com ? parseFloat(rider_report_summary.com).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
        <td
          class="text-xs-right"
        >{{rider_report_summary.net_revenue ? parseFloat(rider_report_summary.net_revenue).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
        <td
          class="text-xs-right"
        >{{rider_report_summary.credit ? parseFloat(rider_report_summary.credit).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
        <td
          class="text-xs-right"
        >({{rider_report_summary.tax_com ? parseFloat(rider_report_summary.tax_com).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }})</td>
        <!-- <td>{{rider_report_summary.cash ? parseFloat(rider_report_summary.cash).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td> -->
      </template>
    </v-data-table>
    <div class="main-title mt-4 mb-3">SUMMARY</div>
    <v-card style="border-radius:10px;">
      <v-card-text>
        <v-layout justify-center>
          <v-flex xs5>
            <div>
              <span class="title-store">Rider</span>
              <div
                style="color:#898989;"
              >{{config_path.datetime_start}} - {{config_path.datetime_end}}</div>
              <v-divider class="mb-3" />
            </div>
            <table width="100%">
              <tr>
                <td class="text-table">Total riders</td>
                <td
                  class="text-xs-right"
                >{{rider_report_list.length ? (parseFloat(rider_report_list.length).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : rider_report_list.length}}</td>
              </tr>
              <tr>
                <td class="text-table">Total revenues</td>
                <td
                  class="text-xs-right"
                >{{rider_report_summary.revenue ? (parseFloat(rider_report_summary.revenue).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : rider_report_summary.revenue}}</td>
              </tr>
              <tr>
                <td class="text-table">Deduct Package 20%</td>
                <td
                  class="text-xs-right"
                >{{rider_report_summary.com ? (parseFloat(rider_report_summary.com).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : rider_report_summary.com}}</td>
              </tr>
              <tr>
                <td class="text-table">Net revenues</td>
                <td
                  class="text-xs-right"
                  style="text-decoration:underline;"
                >{{rider_report_summary.net_revenue ? (parseFloat(rider_report_summary.net_revenue).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : rider_report_summary.net_revenue}}</td>
              </tr>
            </table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "name"
        },
        { text: "Status", value: "Status", sortable: false },
        { text: "Rider name", value: "rider_name", sortable: false },
        { text: "Start date", value: "date", sortable: false, align: "center" },
        { text: "Tel.", value: "tel", sortable: false, align: "center" },
        {
          text: "Food/Mes/Free",
          value: "service_foodmes",
          sortable: false
        },
        { text: "Revenue.", value: "revenue", sortable: false },
        { text: "Com. 20%.", value: "com", sortable: false },
        { text: "Net revenues", value: "net_revenue", sortable: false },
        { text: "Credit", value: "credit", sortable: false },
        { text: "Tax com.", value: "tax_com", sortable: false }
        // { text: "Cash", value: "cash", sortable: false }
      ],
      column_items: [{ text: "Revenue.", value: "revenue", sortable: false }],
      asc_desc: "asc",
      sort_column: "no_default",
      isSort: false
    };
  },
  watch: {
    rider_report_list() {
      if (this.isSort == false) {
        this.asc_desc = "asc";
        this.sort_column = "no_default";
      }
    }
  },
  computed: {
    ...mapState({
      config_path: state => state.fetchRiderReport.clone_config_path,
      rider_report_summary: state =>
        state.fetchRiderReport.rider_report_summary,
      rider_report_list: state => state.fetchRiderReport.rider_report_list
    })
  },
  methods: {
    async sortBy() {
      if (this.sort_column == undefined) {
        this.sort_column = "no_default";
        this.asc_desc = "asc";
      }

      this.isSort = true;
      const send_json_data = {
        data: this.rider_report_list,
        field: this.sort_column,
        asc_desc: this.asc_desc
      };

      await this.$store.dispatch("sortData", send_json_data);
      await this.$store.commit("fetchRiderReport/getExportReportRiderList");
      this.$store.commit("fetchRiderReport/getExportSummary");
      this.isSort = false;
    },
    selectAscDesc(value) {
      this.asc_desc = value;
      this.sortBy();
    }
  }
};
</script>
<style scoped>
.sort-btn {
  cursor: pointer;
  height: 30px;
  width: 30px;
  background-color: #fafafa;
  border: 1px solid #b8b8b8;
  border-radius: 10px;
  color: #757575;
  margin-top: 10px;
  margin-left: 20px;
}
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.text-table {
  font-weight: bold;
  line-height: 30px;
}
.title-store {
  font-size: 19px;
  font-weight: bold;
}
</style>

